module.exports = __webpack_public_path__ + "img/like.03bea10a.svg";